<template>
<div
    style="position: absolute; font-size: 13px; top: 75px; height: 189px; left: 0px"
    :style="elementStyle('additional-info')"
>
  <div class="rfq-view-additional-info">
    <additional-info :paintCode="paintCode" :quoteNumber="quoteNumber"
                     :buildDate="buildDate" :vin="vin"></additional-info>
  </div>


  <div class="d-flex" :style="{width: isRFQPriced && !isShowButton ? getWidth('rfq-view-table') + 15 + 'px': ''}">
    <div class="" id="rfq-view-thead-wrapper" style="overflow-x: auto; margin-left: 15px" :style="{width: (isCanReOrder && areaForOrderButton > 29 ? getWidth('rfq-view-table') - 215 : getWidth('rfq-view-table')) + 'px'}" @scroll="onScroll">
      <div class="" :style="elementStyle('rfq-view-thead')">
        <div class="sticky-rfq-view-header">
          <div :style="elementStyle('rfq-view-line-column')" class="part-list-line align-top sticky-rfq-view-header-item" style="position: sticky; z-index: 5;">
            <div>Line</div>
          </div>
          <div :style="elementStyle('rfq-view-part-list-column')" class="part-list-part-name align-top sticky-rfq-view-header-item" style="position: sticky; z-index: 5;">
            <div class="d-flex justify-content-start">
              <div>Parts List</div>
              <span class="rfq-table-sort-icon" v-on:click="supplierPrice.sortBy('name')"></span>
            </div>
          </div>
          <div :style="elementStyle('rfq-view-part-number-column')" class="part-list-number text-center align-top sticky-rfq-view-header-item" style="position: sticky; z-index: 5;">
            <div class="d-flex justify-content-start">
              <div class="div-number">Part Number</div>
              <span class="ml-2 rfq-table-sort-icon" v-on:click="supplierPrice.sortBy('number')"></span>
            </div>
          </div>
          <div
              :style="elementStyle('rfq-view-qty-column')"
              style="padding-right: 5px; padding-left: 5px; position: sticky; z-index: 5"
              class="text-center align-top sticky-rfq-view-header-item">
            <div class="d-flex justify-content-start">
              <div class="div-qty">Qty</div>
              <span class="rfq-table-sort-icon" v-on:click="supplierPrice.sortBy('qty')"></span>
            </div>
          </div>
          <div
              v-if="isExistListColumn && ((position === 2 || position === 3 || position === 4) || (position===2 && status==='Cancelled'))"
              style="position: sticky; z-index: 5;"
              class="part-list-rrp text-center align-top sticky-rfq-view-header-item" :style="elementStyle('rfq-view-rrp-column')">
            <div class="d-flex justify-content-start">
              <div class="div-qty">List</div>
              <span class="rfq-table-sort-icon" v-on:click="supplierPrice.sortBy('rrp')"></span>
            </div>
          </div>
          <div
              v-for="supplier in supplierPrice.orderedSuppliers"
              :key="supplier.orderId ? supplier.orderId : supplier.id"
              :class="{
                'selected-col': !supplier.isRfqToSupplierStatusDecline && ((supplierPrice.selectedSupplierId === supplier.id && supplierPrice.orderedSuppliers.length > 1)|| isSelectedAllParts(supplier)) && isClickable,
                'supplier-column-highlight': isActiveColumn(supplier.id)
              }"
              @click="supplierClicked(supplier)"
              @contextmenu.prevent="$emit('openContextMenu', {supplier: supplier, e: $event})"
              @mouseleave="setActiveSupplier(null)"
              @mouseover="setActiveSupplier(supplier.id)"
              class="text-center align-top sticky-rfq-view-header-item" :style="elementStyle('rfq-view-supplier-' + supplier.id)"
              style="max-width: auto; position: relative; z-index: 1">
            <div
                v-b-tooltip.hover="{
                customClass: 'ps-tooltip',
                html: true,
                title:  isBlinkingGreen(-1) && (supplier.type === 'OEM-GEN' || supplier.type === 'OEM/GEN') ? supplier.name + ' has submitted Part Nbrs & List' : `Quote NBR - ${supplier.dmsQuoteNumber}`,
                placement:'leftbottom',
                disabled: isBlinkingGreen(-1) && (supplier.type === 'OEM-GEN' || supplier.type === 'OEM/GEN') ? false : supplier.dmsQuoteNumber == null
              }"
                :class="{'blinking-green': isBlinkingGreen(-1) && (supplier.type === 'OEM-GEN' || supplier.type === 'OEM/GEN')}"
                @click="unBlinkPart(-1)"
                class="supplier-name text-center"
            >{{ supplier.name }}
              <span v-if="supplier.isNonRegistered" style="color: red">
                <br/> Non-Registered
              </span>
            </div>
            <div class="supplier-icon text-center">
              <img v-if="supplier.logo" :src="supplier.logo">
              <template v-if="isRFQPriced && ((supplier.secondRequestBestPrice == true || supplier.secondRequestBestPrice == false) || (supplier.thirdRequestBestPrice == true || supplier.thirdRequestBestPrice == false))">
                <div class="d-flex" style="justify-content: center">
                  <i class='bx bx-lock-alt' style="color: #bd5008;"
                     v-if="isLockedSupplier(supplier)"
                     v-b-tooltip.hover="{
                    customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                    html: true,
                    title: 'This suppliers pricing is locked in.',
                    placement:'righttop',
                  }"></i>
                  <i
                      v-if="supplier.isNonRegistered"
                      class='bx bx-error' style="color: #bd5008;"></i>
                  <i
                      v-if="supplier.isNonRegistered && supplier.pdfFile && supplier.pdfFile.src"
                      class='bx bxs-file-pdf'
                      @click="$emit('selectedPdf', supplier.pdfFile.src)"
                      v-b-tooltip.hover="{
                        customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                        html: true,
                        title: 'View PDF',
                        placement:'righttop',
                      }"
                      style="color: #bd5008;"></i>
                  <i
                      v-if="isUnLockedSupplier(supplier)"
                      class='bx bx-lock-open-alt'
                      v-b-tooltip.hover="{
                        customClass: 'ps-tooltip supplier-icon-ps-tooltip',
                        html: true,
                        title: 'Price change unlocked',
                        placement:'righttop',
                      }"
                      style="color: #4b8823;"></i>
                </div>
              </template>
            </div>
            <div v-if="supplier.lowestTotalPrice && 1==-1"
                 class="supplier-type text-center justify-content-center theme-color">
              BEST VALUE
            </div>
            <div class="supplier-type text-center" :class="{'supplier-type-ordered': status === 'Ordered'}">
              {{ supplier.type }}
            </div>
            <div class="part-list-company-color" :style="{ background: getSupplierColor(supplier) }"></div>
          </div>
          <div  v-if="status === 'Received'" :style="elementStyle('rfq-view-action-column')" class="part-list-action text-center align-top sticky-rfq-view-header-item">
            <div>
              <div class="div-action">Action</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="" v-if="isShowButton">
      <div v-if="isRFQPriced" class="col-12 col-lg-auto order-md-2 px-lg-3 best-value">
        <b-button
            style="margin-left: 16px"
            class="tab__button active active-ordered-button"
            :disabled="(countOfSelectedParts == 0) || isSelectedNRSuppParts"
            :class="{'active-ordered-button-2': (countOfSelectedParts == 0) || isSelectedNRSuppParts, 'selection-button':isRfqSentToSingleSupplier, 'rfq-order-button-blinked-orange': isQuoteExpired}"
            block
            variant="outline-primary"
            @click="$emit('handlePriceSetSelectorPressed', 'selection')">

          Order Selected Parts

          <i v-if="isQuoteExpired" v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title: 'Quote Expired by the Supplier', placement:'leftbottom'}" class="bx bx-error-alt"
          style="font-size: 16px;position: absolute; right: 8px; bottom: 13px;"></i>
        </b-button>
      </div>
    </div>

    <div v-if="isCanReOrder && isRFQOrdered && isCanReOrder && areaForOrderButton > 29" class="d-flex flex-column" style="background-color: white">
      <b-button
          class="form-control rfq-ordered-insurer-btn"
          :class="{'active-insurer-btn': selectedPriceSet === s.name}"
          v-for="s in orderedPriceSets"
          @click="$emit('handlePriceSetSelectorPressed', s.name)"
          :key="s.name">
        {{s.label}}
      </b-button>
      <b-button
          class="form-control rfq-ordered-order-btn"
          :class="{'rfq-ordered-order-btn-disabled': (countOfSelectedParts2 == 0) || isSelectedNRSuppParts}" :disabled="(countOfSelectedParts2 == 0) || isSelectedNRSuppParts"
          @click="$emit('orderCreate', selectedParts)"
      >Order Selected Parts</b-button>
    </div>
  </div>
</div>
</template>

<script>
import AdditionalInfo from '../rfq-view/additional-info'
import _ from "lodash";
import Axios from "axios";
import {isMobileOnly} from "mobile-device-detect";

export default {
  name: "rfq-view-sticky-header",
  components: {
    AdditionalInfo
  },
  props: {
    orderedPriceSets: {
      type: Array,
      default: () => []
    },
    selectedPriceSet: {
      type: String,
      default: () => ''
    },
    supplierPrice: {
      type: Object,
      required: true
    },
    areaForOrderButton: {
      type: Number,
      default: 0
    },
    isRFQOrdered: {
      type: Boolean,
      default: false,
    },
    rfqId: {
      type: String,
      default: () => ''
    },
    rfq: {
      type: Object,
      default: () => {}
    },
    status: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      default: 1
    },
    isRFQSubmitted: {
      type: Boolean,
      default: false,
    },
    isRFQPriced: {
      type: Boolean,
      default: false,
    },
    isRfqSentToSingleSupplier: {
      type: Boolean,
      default: false,
    },
    isQuoteExpired: {
      type: Boolean,
      default: false,
    },
    isAvailableOrderParts: {
      type: Boolean,
      default: false,
    },
    vin: {
      type: String,
      default: '',
    },
    buildDate: {
      type: String,
      default: '',
    },
    quoteNumber: {
      type: String,
      default: '',
    },
    paintCode: {
      type: String||Boolean,
      default: null
    },
    isReapirRFQStatus: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      columnWidths: {},
      columnHeight: {},
      columnPadding: {},
      leftPositions: {},
      activeSupplierId: null,
      isClickable: false,
      isShowButton: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.setColumnSize);
    window.addEventListener('scroll', this.setColumnSize);
    let el = document.getElementById('rfq-view-table')
    el.addEventListener('scroll', this.onTableScroll)
    this.setColumnSize();
    this.isClickable = (this.status === 'Priced')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setColumnSize);
    window.removeEventListener('scroll', this.setColumnSize);
    // let el = document.getElementById('rfq-view-table')
    // el.removeEventListener('scroll', this.onTableScroll)
  },
  computed: {
    isMobileOnly () {
      return isMobileOnly
    },
    isSelectedNRSuppParts() {
      return !!_.find(this.supplierPrice.orderedSuppliers, (s) => {
        return !_.isEmpty(s.selectedParts) && s.isNonRegistered
      })
    },
    isCanReOrder() {
      return this.rfq.status === 'Ordered'
          && ((this.isRfqSentToMultipleSupplier && (_.some(this.rfq.partsOrdered, (p) => { return p.isCancelled || p.isHasCredit }) || _.some(this.allParts, (prt) => {return !prt.isOffer})))
              || (!this.isRfqSentToMultipleSupplier && _.some(this.allParts, (prt) => {return !prt.isOffer})))
    },
    isRfqSentToMultipleSupplier () {
      if (this.rfq?.parts_to_suppliers) {
        return Object.keys(this.rfq.parts_to_suppliers).length > 1
      }
      return false
    },
    countOfSelectedParts () {
      let filteredSelectedParts = []
      _.forEach(this.supplierPrice.orderedSuppliers, (s) => {
        _.forEach(s.selectedParts, (id) => {
          _.forIn(s.parts, (part, partId) => {
            if ((Number(partId) === 0 && part[id] && part[id].id && part[id].linkType !== 'withNoCost' && part[id].type !== 'delivery') || (part && part.id && Number(partId) === Number(id) && part.linkType !== 'withNoCost' && part.type !== 'delivery')) {
              filteredSelectedParts.push(id)
            }
          })
        })
      })
      return filteredSelectedParts.length
    },
    countOfSelectedParts2 () {
      return this.selectedParts.length
    },
    selectedParts () {
      let filteredSelectedParts = []
      _.forEach(this.supplierPrice.orderedSuppliers, (s) => {
        _.forEach(s.selectedParts, (id) => {
          _.forIn(s.parts, (part, partId) => {
            let offer = _.find(s.offers, (ofr) => {
              return Number(ofr.originalPartId) == Number(id)
            })
            let isAlreadyOrdered = _.some(this.rfq.partsOrdered, (p) => {return Number(p.offerId) === Number(offer?.id)})
            if (!isAlreadyOrdered && ((Number(partId) === 0 && part[id] && part[id].id && part[id].linkType !== 'withNoCost' && part[id].type !== 'delivery') || (part && part.id && Number(partId) === Number(id) && part.linkType !== 'withNoCost' && part.type !== 'delivery'))) {
              filteredSelectedParts.push(offer.id)
            }
          })
        })
      })
      return filteredSelectedParts
    },
    allParts () {
      console.log('allParts', this.supplierPrice.parts)
      return this.supplierPrice.parts//.concat(this.manualParts);
    },
    isExistListColumn () {
      return this.OEMSupplier ? true : false
    },
    OEMSupplier () {
      return this.supplierPrice.OEMSupplier
    },
  },
  methods: {
    isLockedSupplier(supplier) {
      return ((!supplier.isNonRegistered &&supplier.secondRequestBestPrice === false && supplier.thirdRequestBestPrice !== true && supplier.thirdRequestBestPrice !== false)
              || (!supplier.isNonRegistered && supplier.thirdRequestBestPrice === false)
              || (supplier.isNonRegistered && supplier.secondRequestBestPrice === true))
          || (supplier.isNonRegistered && this.rfq.thirdRequestBestPrice !== true)
    },
    isUnLockedSupplier(supplier) {
      return ((!supplier.isNonRegistered && supplier.secondRequestBestPrice === true && supplier.thirdRequestBestPrice !== true && supplier.thirdRequestBestPrice !== false)
          ||(!supplier.isNonRegistered && supplier.thirdRequestBestPrice === true)
          || (supplier.isNonRegistered && this.rfq.thirdRequestBestPrice == true)
      )
    },
    onScroll() {
      this.$nextTick(() => {
        let el = document.getElementById("rfq-view-table");
        let el2 = document.getElementById("rfq-view-thead-wrapper");

        el.scrollLeft = el2.scrollLeft;
      })
    },
    getSupplierColor(supplier){
      switch (supplier.type){
        case 'OEM-GEN':
          return '#083d77'
        case 'OEM-PAR':
          return '#ee964b'
        case 'OEM-ALT':
          return '#f4d35e'
        case 'CERT-AFTM':
          return '#fa7a61'
        case 'AFTM':
          return '#6b8f71'
        case 'USED':
          return '#b287a3'
        case 'RECO':
          return '#57b8ff'

        default:
          return '#a3a3a3'
      }
    },
    setLeftPosition() {
      let lineWidth = document.getElementById('rfq-view-line-column').clientWidth;
      let partListWidth = document.getElementById('rfq-view-part-list-column').clientWidth;
      let partNumberWidth = document.getElementById('rfq-view-part-number-column').clientWidth;
      let qtyWidth = document.getElementById('rfq-view-qty-column').clientWidth;
      // let rrpWidth = document.getElementById('rfq-view-rrp-column').clientWidth;

      this.$nextTick(() => {
        this.$set(this.leftPositions, 'rfq-view-line-column', '0px')
        this.$set(this.leftPositions, 'rfq-view-part-list-column', lineWidth + 'px')
        this.$set(this.leftPositions, 'rfq-view-part-number-column', lineWidth + partListWidth + 'px')
        this.$set(this.leftPositions, 'rfq-view-qty-column', lineWidth + partListWidth + partNumberWidth + 'px')
        this.$set(this.leftPositions, 'rfq-view-rrp-column', lineWidth + partListWidth + partNumberWidth + qtyWidth + 'px')
      })
    },
    getLeftPosition(type) {
      if (this.leftPositions[type]) {
        return this.leftPositions[type]
      }
      return '0px'
    },
    unBlinkPart (id) {
      let ids = []
      if (id == -1) {
        _.forEach(this.allParts, (p) => {
          ids.push(p.id)
        })
      } else {
        ids.push(id)
      }
      if (!_.isEmpty(ids)) {
        Axios.post('/ir/repairer/rfq/' + this.rfqId, {
          viewedParts: ids
        })
            .then(response => {
              if (response.data._status) {
                _.forEach(ids, (id) => {
                  let part = _.find(this.allParts, (p) => {
                    return Number(p.id) === Number(id)
                  })
                  if (part) {
                    part.isNotViewed = false
                  }
                })
                this.$root.$emit('bv::hide::tooltip')
              }
            })
      }
    },
    isBlinkingGreen (id) {
      if (id == -1) {
        return !_.isEmpty(this.OEMSupplier) && this.OEMSupplier.rfqToSupplierStatus === 'New' && this.isRFQSubmitted && _.filter(this.allParts, (prt) => {
          return prt.numberBySupplier !== null && prt.rrpBySupplier !== null && prt.isNotViewed
        }).length
      } else {
        let part = _.find(this.allParts, (prt) => {
          return Number(prt.id) === Number(id)
        })
        return !_.isEmpty(this.OEMSupplier) && this.OEMSupplier.rfqToSupplierStatus === 'New' && this.isRFQSubmitted
            && part && part.numberBySupplier !== null && part.rrpBySupplier !== null && part.isNotViewed
      }
    },
    supplierClicked (supplier) {
      if (!this.isClickable || supplier.isRfqToSupplierStatusDecline) return
      if (this.isSelectedAllParts(supplier) || !_.isEmpty(supplier.selectedParts)) {
        this.supplierPrice.unSelectAllPartsFrom(supplier.id)
        this.$emit('unselect')
      } else {
        this.supplierPrice.selectAllPartsFrom(supplier.id)
        this.$emit('select', supplier.id, null, null)
      }
    },
    setActiveSupplier (id) {
      if (!this.isRFQPriced) {
        return
      }
      this.$emit('changedActiveSupplierId', id)
    },
    isActiveColumn (id) {
      if (!this.isRFQPriced) {
        return
      }
      return id === this.activeSupplierId
    },
    isSelectedAllParts (supplier) {
      console.log('isSelectedAllParts2', supplier)
      return supplier && supplier.hasOwnProperty('getPartsLength') && supplier?.selectedParts?.length === supplier.getPartsLength()
    },
    elementStyle(id) {
      let obj = {
        width: this.getWidthForElement(id) + 'px',
        height: this.getHeightForElement(id) + 'px',
        paddingRight: this.getPaddingForElement(id, 'right'),
        paddingLeft: this.getPaddingForElement(id, 'left'),
        paddingTop: this.getPaddingForElement(id, 'top'),
        paddingBottom: this.getPaddingForElement(id, 'bottom'),
      }
      if (id === 'rfq-view-line-column' || id === 'rfq-view-part-list-column' || id === 'rfq-view-part-number-column' || id === 'rfq-view-qty-column' || id === 'rfq-view-rrp-column') {
        obj.left = this.getLeftPosition(id)
        obj.backgroundColor = 'rgb(227, 228, 231) !important'
      }
      return obj
    },
    onTableScroll() {
      let el = document.getElementById("rfq-view-table");
      let el2 = document.getElementById("rfq-view-thead-wrapper");
      if (el2) {
        el2.scrollLeft = el.scrollLeft;
      }
    },
    getWidthForElement(id) {
      if (this.columnWidths[id]) {
        return this.columnWidths[id]
      }
      return 0
    },
    getHeightForElement(id) {
      if (this.columnHeight[id]) {
        return this.columnHeight[id]
      }
      return 0
    },
    getPaddingForElement(id, type) {
      if (this.columnPadding?.[id]?.[type]) {
        return this.columnPadding[id][type]
      }
      return 0
    },
    getWidth(id) {
      let el = document.getElementById(id)
      return el.clientWidth
    },
    getHeight(id) {
      let el = document.getElementById(id)
      return el.clientHeight
    },
    getPadding(id) {
      let el = document.getElementById(id)
      return {
        left: window.getComputedStyle(el, null).getPropertyValue('padding-left'),
        top: window.getComputedStyle(el, null).getPropertyValue('padding-top'),
        right: window.getComputedStyle(el, null).getPropertyValue('padding-right'),
        bottom: window.getComputedStyle(el, null).getPropertyValue('padding-bottom'),
      }
    },
    setColumnSize() {
      let partListWrapper = document.getElementById('part-list-wrapper');

      let button = document.getElementById('selection-button')

      if (partListWrapper && partListWrapper.clientWidth - 15 - this.getWidth('rfq-view-table') >= 227 && button && button.getBoundingClientRect().y <= 215) {
        this.isShowButton = true
      } else {
        this.isShowButton = false
      }

      this.setLeftPosition()
      let ids = ['additional-info', 'rfq-view-thead', 'rfq-view-line-column', 'rfq-view-part-list-column', 'rfq-view-part-number-column', 'rfq-view-qty-column', 'rfq-view-rrp-column', ]
      _.forEach(this.supplierPrice.orderedSuppliers, (s) => {
        ids.push('rfq-view-supplier-' + s.id)
      })
      if (this.status === 'Received') {
        ids.push('rfq-view-action-column')
      }

      _.forEach(ids, (id) => {
        this.$nextTick(() => {
          this.$set(this.columnWidths, id, this.getWidth(id))
          this.$set(this.columnHeight, id, this.getHeight(id))
          this.$set(this.columnPadding, id, this.getPadding(id))
        })
        // this.columnWidths[id] = this.getWidth(id)
      })
    }
  }
}
</script>

<style>
.V3 .active-ordered-button-2 {
  background-color: #74ce9b !important;
  border-color: #74ce9b !important;
}
.rfq-order-button-blinked-orange {
  animation-name: rfq-order-btn-blinked-orange;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

@keyframes rfq-order-btn-blinked-orange {
  50% {
    background-color: #F59345;
    border-color: #F59345;
  }
}
</style>
<style scoped>
.supplier-icon-ps-tooltip >>> .tooltip-inner{
  border-radius: 10px 10px 10px 0 !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-left >>> .tooltip-inner{
  border-radius: 10px 10px 0 10px !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-right{
  top: -20px !important;
  left: -14px !important;
}
.supplier-icon-ps-tooltip.bs-tooltip-left{
  top: -20px !important;
  left: 18px !important;
}
.supplier-icon .bx{
  font-size: 27px;
  opacity: 1 !important;
}
.part-list-company-color{
  height: 5px;
  width: 80%;
  background: #083d77;
  border-radius: 5px;
  position: absolute;
  bottom: 0;
  left: 14px;
}

.supplier-name {
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  min-height: 54px;
  margin-bottom: 10px;
}

.supplier-type {
  color: #1C1F39;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
}

.supplier-type-ordered {
  padding-top: 15px;
}

/*.sticky-rfq-view-header .part-list-part-name {*/
/*  max-width: 220px !important;*/
/*  width: 220px !important;*/
/*}*/

.selected-col {
border: 2px solid #78b1ba;
}

.sticky-rfq-view-header .rfq-table-sort-icon {
  background-image: url(data:image/svg+xml;base64,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);
  height: 16px;
  width: 8px;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}

.sticky-rfq-view-header .sticky-rfq-view-header-item {
  background-color: rgba(27,30,56,0.12) !important;
  height: 127px;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
  padding: 26px 15px 10px 15px;
  color: #000000;
  width: 180px;
  cursor: pointer;
}

.sticky-rfq-view-header {
  background-color: white !important;
  display: flex;
}

.rfq-view-additional-info {
  background-color: white;
  padding-top: 15px;
  padding-bottom: 15px;
}
#rfq-view-thead-wrapper {
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}

#rfq-view-thead-wrapper::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
</style>
